var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReferral = function SvgReferral(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20.5a4.002 4.002 0 0 0 3.595-2.244l-1.471-.436A2.5 2.5 0 0 1 7.5 16.5l-.001-.056-1.5-.446L6 16.5l.005.2a4 4 0 0 0 3.995 3.8Z",
    fill: "#999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 6.263a2.25 2.25 0 0 0-2.89-2.157L3.61 8.712A2.25 2.25 0 0 0 2 10.87v2.262a2.25 2.25 0 0 0 1.609 2.157l2.39.71 1.5.447 4.625 1.375 1.471.436 5.514 1.64A2.252 2.252 0 0 0 22 17.737V6.263Z",
    fill: "#666"
  })));
};
export default SvgReferral;